<template>
  <ModalComp
    :is-visible="isVisible"
    title="Annuler la commande"
    size="sm"
    @update:is-visible="$emit('update:isVisible', $event)"
  >
    <template #body>
      <p class="mb-3 text-sm text-gray-700">Pourquoi souhaitez-vous annuler cette commande ?</p>
      <label
        v-for="option in options"
        :key="option.value"
        class="mb-2 flex cursor-pointer items-center gap-2 rounded-lg border p-3"
      >
        <input v-model="reason" type="radio" :value="option.value" />
        <span>{{ option.label }}</span>
      </label>
      <textarea
        v-if="reason === 'OTHER'"
        v-model="detail"
        maxlength="500"
        rows="4"
        placeholder="Précisez la raison"
        class="mt-2 w-full rounded-lg border border-gray-300 p-3"
      ></textarea>
      <p
        v-if="reason === 'OTHER'"
        :class="['mt-1 text-right text-xs', detail.length >= 450 ? 'text-red-600' : 'text-gray-500']"
      >
        {{ detail.length }} / 500 caractères
      </p>
    </template>
    <template #footer>
      <button
        type="button"
        class="rounded-lg border border-gray-300 px-4 py-2 text-sm"
        :disabled="loading"
        @click="$emit('update:isVisible', false)"
      >
        Retour
      </button>
      <button
        type="button"
        class="rounded-lg bg-red-600 px-4 py-2 text-sm text-white disabled:opacity-50"
        :disabled="loading || !reason || (reason === 'OTHER' && !detail.trim())"
        @click="$emit('confirm', reason, reason === 'OTHER' ? detail.trim() : undefined)"
      >
        {{ loading ? "Annulation..." : "Confirmer l'annulation" }}
      </button>
    </template>
  </ModalComp>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import ModalComp from "@/components/ui/ModalComp.vue";

const props = defineProps<{ isVisible: boolean; loading?: boolean }>();
defineEmits<{
  "update:isVisible": [value: boolean];
  confirm: [code: string, detail?: string];
}>();

const options = [
  { value: "PRODUCTS_UNAVAILABLE", label: "Produits indisponibles" },
  { value: "CANNOT_FULFILL", label: "Impossible de préparer la commande" },
  { value: "BUYER_REQUEST", label: "Annulation demandée par l’acheteur" },
  { value: "OTHER", label: "Autre" },
];

const reason = ref("");
const detail = ref("");

watch(reason, (value) => {
  if (value !== "OTHER") detail.value = "";
});

watch(
  () => props.isVisible,
  (visible) => {
    if (visible) {
      reason.value = "";
      detail.value = "";
    }
  },
);
</script>
